<template>
    <div class="block md:flex items-center p-3">
        <div class="w-full md:w-3/5 ">
            <div class="chart-inner-headline pl-4">{{$t('pages.controlpanel.index.controls.average_price')}}</div>
            <div class="flex justify-center" :id="averagePriceGaugeId"></div>
        </div>
        <div class="w-full md:w-2/5">
            <table class="table-average-price">
                <tbody>
                    <tr>
                        <td class="pr-3 py-4 text-gray-500 align-items-end"></td>
                        <td class="py-4 text-xl text-right">{{ shopPrice | toCurrency }}</td>
                        <td class="py-4 text-xs pl-4">{{labelShopPrice}}</td>
                    </tr>
                    <tr>
                        <td class="pr-3 py-4 text-gray-500 align-items-end"><icon name="up-filled" class="w-5 h-5 fill-gray-400"/></td>
                        <td class="py-4 text-xl text-right">{{ highest | toCurrency }}</td>
                        <td class="py-4 text-xs pl-4">{{labelHighest}}</td>
                    </tr>
                    <tr>
                        <td class="pr-3 py-4"><icon name="average" class="w-5 h-5 fill-gray-400"/></td>
                        <td class="py-4 text-xl text-right">{{  average | toCurrency }}</td>
                        <td class="py-4 text-xs pl-4">{{labelAverage}}</td>
                    </tr>
                    <tr>
                        <td class="pr-3 py-4"><icon name="down-filled" class="w-5 h-5 fill-gray-400"/></td>
                        <td class="py-4 text-xl text-right">{{ lowest | toCurrency }}</td>
                        <td class="py-4 text-xs pl-4">{{labelLowest}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import * as GaugeChart from 'gauge-chart/dist/bundle.mjs';

export default {
    components: {
        Link,
        Icon,
        GaugeChart
    },
    props: {
        labelShopPrice: String,
        labelHighest: String,
        labelAverage: String,
        labelLowest: String,
        shopPrice: Number,
        highest: Number,
        average: Number,
        lowest: Number,
        dangerThreshold: {
            Type: Number,
            default: 40
        },
        warningThreshold: {
            Type: Number,
            default: 75
        }
    },
    data() {
        return {
            averagePriceGaugeChart: null,
            averagePriceGaugeId: 'average-price-gauge'
        }
    },
    watch: {
        lowest: function() {
            this.updateGauge();
        },
        average: function() {
            this.averagePriceGaugeChart.updateNeedle(this.averageInPercent);
        },
        highest: function() {
            this.updateGauge();
        }
    },

    computed: {
        averageInPercent: function() {
            return Math.max(0, (this.average - this.lowest) / (this.highest - this.lowest) * 100);
        },
        options: function() {
            return {
                'needleValue': this.averageInPercent,
                'rangeLabel':[
                    this.lowest.toString(),
                    this.highest.toString()
                ],
                'arcDelimiters':[
                    this.dangerThreshold,
                    this.warningThreshold
                ],
                chartWidth: 300,
                arcColors: [
                    getComputedStyle(document.body).getPropertyValue('--gaugeOne'),
                    getComputedStyle(document.body).getPropertyValue('--gaugeTwo'),
                    getComputedStyle(document.body).getPropertyValue('--gaugeThree')
                ],
                needleColor: 'rgb(107 114 128)',
                hasNeedle:true
            };
        }
    },
    mounted() {
       this.createGauge();
    },
    methods: {
        updateGauge() {
            this.averagePriceGaugeChart?.removeGauge();
            this.createGauge();
        },
        createGauge() {
            let element = document.querySelector('#'+this.averagePriceGaugeId);
            this.averagePriceGaugeChart = GaugeChart.gaugeChart(element, 300, this.options);
            this.averagePriceGaugeChart.updateNeedle(this.averageInPercent);
        }
    }
}
</script>
